module.exports = __webpack_public_path__ + "static/media/background.b0562802.png";